<script setup lang="ts">
import {
  faCheckCircle,
  faMessageExclamation,
  faQuestionCircle,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { computed } from 'vue';
import FontAwesomeIcon from './FontAwesomeIcon.vue';

const props = defineProps<{
  type: 'default' | 'danger' | 'warning' | 'success';
  center?: boolean;
}>();

const icon = computed(() => {
  switch (props.type) {
    case 'danger':
      return faTriangleExclamation;
    case 'warning':
      return faMessageExclamation;
    case 'success':
      return faCheckCircle;
    default:
    case 'default':
      return faQuestionCircle;
  }
});
</script>

<template>
  <div class="tml-alert flex p-2" :class="{ [type]: true, 'justify-center': center }">
    <FontAwesomeIcon class="w-6 my-1 mr-2" :icon="icon" />
    <slot />
    <slot name="actions" />
  </div>
</template>

<style>
.tml-alert {
  @apply rounded-[--tml-alert-radius];
}

.tml-alert.default {
  @apply text-[--tml-alert-default-text-color] bg-[--tml-alert-default-background-color];
  @apply border-[--tml-alert-default-border-color] border-[length:--tml-alert-border-width];
}
.tml-alert.default > svg {
  @apply text-[--tml-default-color];
}

.tml-alert.success {
  @apply text-[--tml-alert-success-text-color] bg-[--tml-alert-success-background-color];
  @apply border-[--tml-alert-success-border-color] border-[length:--tml-alert-border-width];
}
.tml-alert.success > svg {
  @apply text-[--tml-success-color];
}

.tml-alert.warning {
  @apply text-[--tml-alert-warning-text-color] bg-[--tml-alert-warning-background-color];
  @apply border-[--tml-alert-warning-border-color] border-[length:--tml-alert-border-width];
}
.tml-alert.warning > svg {
  @apply text-[--tml-warning-color];
}

.tml-alert.danger {
  @apply text-[--tml-alert-danger-text-color] bg-[--tml-alert-danger-background-color];
  @apply border-[--tml-alert-danger-border-color] border-[length:--tml-alert-border-width];
}
.tml-alert.danger > svg {
  @apply text-[--tml-danger-color];
}
</style>
